import React from 'react';
import { Alert } from 'antd';
import * as S from './index.styled';
import { AdvertiserSearch } from '@/@types/AdvertiserSearch';
import { ResData } from '@/@types';
import axiosRequest from '@/api';

interface BusinessVerificationProps {
  setIsVerified: (isVerified: boolean) => void;
  onSuccess: (data: AdvertiserSearch) => void;
  onNotFound: () => void;
  setInputBizNo: (bizNo: { part1: string; part2: string; part3: string }) => void;
  setAdCategory: (category: string) => void;
  setStepValid: (isValid: boolean) => void;
  adCategory: string;
  inputBizNo: { part1: string; part2: string; part3: string };
  errorMessage: string;
  setErrorMessage: (message: string) => void;
}

const BusinessVerification: React.FC<BusinessVerificationProps> = ({
  setIsVerified,
  onSuccess,
  onNotFound,
  setInputBizNo,
  setAdCategory,
  setStepValid,
  adCategory,
  inputBizNo,
  errorMessage,
  setErrorMessage,
}) => {
  const handleBizNoChange = (e: React.ChangeEvent<HTMLInputElement>, part: 'part1' | 'part2' | 'part3') => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setInputBizNo({ ...inputBizNo, [part]: value });
      setErrorMessage(''); // 필드 값이 변경될 때 에러 메시지 초기화
    }
  };

  const handleCategoryClick = (category: string) => {
    setAdCategory(category);
    setStepValid(false); // 카테고리 변경 시 다음 버튼 비활성화
    setErrorMessage(''); // 카테고리 변경 시 에러 메시지 초기화
  };

  const handleVerify = async () => {
    if (!adCategory) {
      setErrorMessage('구분을 선택해주세요.');
      return;
    }
    if (!inputBizNo.part1 || !inputBizNo.part2 || !inputBizNo.part3 || `${inputBizNo.part1}${inputBizNo.part2}${inputBizNo.part3}`.length !== 10) {
      setErrorMessage('올바른 사업자 등록번호를 입력해주세요. ex)000-00-00000 (10자리)');
      return;
    }

    const sanitizedBizNo = `${inputBizNo.part1}${inputBizNo.part2}${inputBizNo.part3}`;

    setErrorMessage(''); // 유효성 검사 통과 후 에러 메시지 초기화

    try {
      const response = await axiosRequest.requestAxios<ResData<AdvertiserSearch>>('post', '/v2/search_advertiser', {
        category: adCategory,
        biz_no: sanitizedBizNo,
      });

      if (response.status === 200) {
        setIsVerified(true);
        setStepValid(true);
        onSuccess(response.data);
      } else {
        setIsVerified(false);
        setStepValid(true);
      }
    } catch (error) {
      setStepValid(true);
      onNotFound();
    }
  };

  return (
    <S.Container>
      <S.Title>가입여부 확인을 위해 아래 정보를 입력해주세요.</S.Title>
      <S.StyledForm>
        <S.FormRow>
          <S.Label>구분</S.Label>
          <S.RadioButtonGroup>
            <S.RadioButton active={adCategory === 'c'} onClick={() => handleCategoryClick('c')}>
              고객사
            </S.RadioButton>
            <S.RadioButton active={adCategory === 'a'} onClick={() => handleCategoryClick('a')}>
              대행사
            </S.RadioButton>
          </S.RadioButtonGroup>
        </S.FormRow>
        <S.FormRow>
          <S.Label>사업자등록번호</S.Label>
          <S.InputGroup>
            <S.StyledInput maxLength={3} value={inputBizNo.part1} onChange={e => handleBizNoChange(e, 'part1')} />
            <span>-</span>
            <S.StyledInput maxLength={2} value={inputBizNo.part2} onChange={e => handleBizNoChange(e, 'part2')} />
            <span>-</span>
            <S.StyledInput maxLength={5} value={inputBizNo.part3} onChange={e => handleBizNoChange(e, 'part3')} />
          </S.InputGroup>
        </S.FormRow>
        {errorMessage && <S.StyledAlert message={errorMessage} type="error" />}
        <S.ButtonGroup>
          <S.VerifyButton onClick={handleVerify}>가입확인</S.VerifyButton>
        </S.ButtonGroup>
      </S.StyledForm>
    </S.Container>
  );
};

export default BusinessVerification;
